import React, { useEffect } from 'react';
import styled from 'styled-components';
import Search from '~/components/homepage/search';
import Image from 'next/image';
import getConfig from 'next/config';
import type { BoatRental } from '~/utils/rentals';
import { transformBoatRental } from '~/utils/rentals';
import { useRouter } from 'next/router';
const { publicRuntimeConfig } = getConfig();

const Hero = ({ boatRental, imgSrc = 'images/rentals/hero.jpg' }: { boatRental: BoatRental; imgSrc: string }) => {
  const router = useRouter();

  useEffect(() => {
    const inputId = 'place_input';
    const inputElement = document.getElementById(inputId) as HTMLInputElement;

    const timeoutId = setTimeout(() => {
      if (inputElement) {
        inputElement.value = boatRental.queryParams.near;
      }
    }, 100);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [router.asPath]);

  return (
    <HeroWrapper id="video_bg">
      <h1>{boatRental.h1}</h1>
      <ImageWrapper>
        <Image
          src={`${publicRuntimeConfig.ASSETS_PREFIX}/${imgSrc}`}
          objectFit="cover"
          objectPosition="100% 100%"
          layout="fill"
          quality={100}
          priority
        />
      </ImageWrapper>
      <Search defaultPlace={transformBoatRental(boatRental)} tiny={true} />
    </HeroWrapper>
  );
};

const HeroWrapper = styled.div`
  height: 60vh;
  max-height: 680px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  text-align: center;
  position: relative;
  margin-top: -60px;
  background: transparent linear-gradient(180deg, #284166b8 0%, #1f334f85 15%, #14213347 100%) 0% 0% no-repeat
    padding-box;

  h1 {
    z-index: 3;
    padding: clamp(40px, 8vh, 100px) 10px 0;
    margin-bottom: 20px;
    position: relative;
    line-height: 1.2;
    color: #ffffff;

    @media (min-height: 780px) {
      margin-bottom: 40px;
    }
  }
`;
const ImageWrapper = styled.div`
  width: 50%;
  flex-basis: auto !important;

  /* Gradient overlay */
  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(
      to bottom,
      rgba(20, 33, 51, 0.65) 0%,
      rgba(20, 33, 51, 0.3) 30%,
      rgba(20, 33, 51, 0) 70%
    );
    z-index: 2;
    pointer-events: none;
  }

  img {
    position: absolute;
    z-index: 1;
  }

  @media screen and (max-width: 700px) {
    width: 100%;
    max-width: 300px;
  }
`;

export default Hero;
